/**
 * S7's spent tubes, their dials (the owner: "love the discarded law tube, not sure how many can be on the ground and how fast
 * they despawn, seems similar to corpses"): how long a spent LAW tube lies where it was dropped and how many each person
 * leaves at once — the Lab's *Spent tubes* rows beside the corpses', else the page's `?tubetime=&tubecap=`, else the
 * defaults (today's: 30 s, three). The host hands them to each person view. Presentation only.
 */
import { LAW_SPENT } from '../rendering/personView';

export interface LawSpentConfig { seconds: number; most: number }
export const LAW_SPENT_DEFAULTS: LawSpentConfig = { seconds: LAW_SPENT.seconds, most: LAW_SPENT.most };

let override: LawSpentConfig | null = null;

/** The Lab's launch sets them (`null` returns to the page's URL / the defaults). */
export function setLawSpentConfig(c: LawSpentConfig | null): void { override = c; }

/** The dials in force: the Lab's, else the page's `?tubetime=&tubecap=`, else the defaults. */
export function lawSpentConfig(): LawSpentConfig {
  if (override) return override;
  try {
    const q = typeof location !== 'undefined' ? new URLSearchParams(location.search) : null;
    if (!q) return LAW_SPENT_DEFAULTS;
    const num = (k: string, d: number, lo: number, hi: number) => { const v = Number(q.get(k)); return q.has(k) && Number.isFinite(v) ? Math.min(hi, Math.max(lo, v)) : d; };
    return { seconds: num('tubetime', LAW_SPENT_DEFAULTS.seconds, 0, 3600), most: Math.round(num('tubecap', LAW_SPENT_DEFAULTS.most, 0, 50)) };
  } catch { return LAW_SPENT_DEFAULTS; }
}
